module.exports = __webpack_public_path__ + "img/prize-3.cefe70f5.png";